import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';
import {rootActions, useAppDispatch, useAppSelector} from "../../data/store";
import {
    ITEMS_PER_PAGE_1,
    ITEMS_PER_PAGE_2,
    ITEMS_PER_PAGE_3,
    ITEMS_PER_PAGE_ALL
} from '../../services/list-page-provider';

export const ItemsPerPage = () => {

    const dispatch = useAppDispatch();
    const itemsPerPage = useAppSelector(store => store.itemsPerPage);

    /**
     * Apply items per page.
     */
    const applyItemsPerPage = (updatedValue: number) => {

        dispatch(
            rootActions.refresh({
                itemsPerPage: updatedValue
            })
        );
    };

    return(
        <div className="flex items-center">
            <select
                className="outline-none"
                aria-label="Items Per Page"
                value={ itemsPerPage }
                onChange={evt => {
                    const value = Number(evt.target.value) || 0;
                    applyItemsPerPage(value);

                    sendGAEvent('JPList', `Items Per Page: ${value.toString()}`);

                    // jump to top
                    window.scrollTo(0, 0);
                }}>
                <option value={ ITEMS_PER_PAGE_1 }>{ ITEMS_PER_PAGE_1 } per page</option>
                <option value={ ITEMS_PER_PAGE_2 }>{ ITEMS_PER_PAGE_2 } per page</option>
                <option value={ ITEMS_PER_PAGE_3 }>{ ITEMS_PER_PAGE_3 } per page</option>
                <option value={ ITEMS_PER_PAGE_ALL }>all</option>
            </select>
        </div>
    )
};